const container = document.querySelector('.middle-side');
const image = document.querySelector('#product-main-image');

container.addEventListener('mouseenter', () => {
    image.style.transform = 'scale(2.5)';
});

container.addEventListener('mouseleave', () => {
    image.style.transform = 'scale(1)';
});

container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();
    const mouseY = e.clientY - rect.top; /* Mouse Y within container */
    const containerHeight = container.offsetHeight; /* 484px */
    const maxOffset = 200; /* Between 90 and 110 */

    /* Normalize mouse position: -1 (top) to 1 (bottom) */
    const normalizedY = (mouseY / containerHeight - 0.5) * 2;
    const offset = maxOffset * normalizedY * -1;

    if (image.style.transform.includes('scale(2.5)')) {
        image.style.transform = `scale(2.5) translateY(${offset}px)`;
        //console.log(`MouseY: ${mouseY.toFixed(0)}, Offset: ${offset.toFixed(0)}`);
    }
});